import React, { FC } from 'react';


const Features: FC = () => <section className='schedule-demo-container'>
                                            <h2>Aqui va a ir las features</h2>
                                       </section>;
                                       
export default Features;                                       